import { useCallback } from 'react';
import { getConfig } from '@config';
import { useIntercom } from '@shared/core/intercom';

/**
 * Custom React hook to trigger a feedback survey.
 */

const intercomFeedbackSurveyId = getConfig()?.intercomFeedbackSurveyId;

export const useFeedBackSurvey = () => {
  const intercom = useIntercom();
  const startSurvey = useCallback(() => {
    if (intercom && intercomFeedbackSurveyId) {
      intercom.startSurvey(intercomFeedbackSurveyId);
    }
  }, [intercom]);
  return startSurvey;
};
